module.exports = __webpack_public_path__ + "img/thumbnail_Wolverine_f_albino.2047482c.png";